import { MESSAGE } from "./message.utils";

let _currentMessages: any = MESSAGE;

/**
 * Vrai quand `_currentMessages` est le dictionnaire de REPLI (français) alors
 * que la langue demandée est autre — le chunk EN/ES/PT n'a jamais répondu et
 * l'attente a été bornée pour ne pas bloquer le bootstrap.
 *
 * Le cache de `translate.pipe` n'est clé que par la LANGUE, pas par l'identité
 * du dictionnaire : cacher dans cet état mettrait du français sous la langue
 * étrangère, durablement, puisque la langue ne change plus à chaud. Le pipe
 * consulte ce drapeau pour s'abstenir.
 *
 * Il vit ICI et pas dans `LanguageService` parce que c'est une propriété des
 * messages courants, pas du service : le pipe n'a rien à savoir de plus sur son
 * service pour en tenir compte.
 */
let _replii = false;

export function setCurrentMessages(messages: any, deRepli = false) {
  _currentMessages = messages;
  _replii = deRepli;
}

/** Le dictionnaire courant est-il un repli ? (cf. `_replii`) */
export function surDictionnaireDeRepli(): boolean {
  return _replii;
}

export class TranslateUtils {
  static argsKey = "#";

  static translate(value: string, args?: any): string {
    if (!value) {
      return "";
    }
    const splitMessage: string[] = value.split(".");

    let message = this.readMessage(splitMessage, 0, _currentMessages);

    if (!message) {
      return value;
    }

    if (args) {
      const keys = Object.keys(args);
      for (const key of keys) {
        message = message.replaceAll(`${this.argsKey}${key}`, args[key]);
      }
    }
    return message;
  }

  static translatePlural(val: string, nb: number, args?: any): string {
    const value = val;
    if (nb <= 1) {
      return this.translate(value, args);
    } else {
      return this.translate(`${value}_plural`, args);
    }
  }

  /**
   * need to return MESSAGE[params[0]][params[1]] ...
   * @param {string[]} params
   * @param {number} index
   * @param response
   * @return {any}
   */
  static readMessage(params: string[], index: number, response) {
    if (params.length === index) {
      return response;
    }

    const message = response[params[index]];
    if (!message) {
      return message;
    }

    return this.readMessage(params, index + 1, message);
  }
}
